import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Observable, map } from 'rxjs';

export interface ContactForm {
  name: string;
  email: string;
  mobile: string;
  subject: string;
  message: string;
}

@Injectable({
  providedIn: 'root'   // ✅ this makes it available app-wide
})
export class ContactService {

  constructor(private httpClient: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

sendContactEmail(contactInfo: ContactForm): Observable<any> {
  return this.httpClient
    .post(
      environment.baseUrl + environment.contactUsApiUrl, // point this at /contact-us/
      contactInfo,
      this.httpOptions
    )
    .pipe(map((result: any) => result));
}
}